// extracted by mini-css-extract-plugin
module.exports = {"categories":"index_categories_2ef_t","category":"index_category_S9Saf","title":"index_title_1PPYR","current":"index_current_b6jKj"};